"use strict";

export default {
  Zusage: "6af2aa62-d8d5-4f99-946e-94cc9fd7d074",
  Absage: "b04ba61f-fb16-4159-b109-bf1805142d12"
};
